export interface TrackableSymptom {
  id: string;
  name: string;
  shortName: string;
  unit: string;
  description: string;
  enabled?: boolean;
  isCustom?: boolean;
}

export const DEFAULT_TRACKABLE_SYMPTOMS: TrackableSymptom[] = [
  { id: 'bloating', name: 'Bloating', shortName: 'Bloating', unit: '/10', description: 'Abdominal fullness & distension', enabled: true },
  { id: 'stomach_pain', name: 'Stomach Pain', shortName: 'Stomach Pain', unit: '/10', description: 'Cramps, spasms, visceral soreness', enabled: true },
  { id: 'heartburn', name: 'Heartburn', shortName: 'Heartburn', unit: '/10', description: 'Acid reflux, indigestion, burning', enabled: true },
  { id: 'reflux', name: 'Reflux', shortName: 'Reflux', unit: '/10', description: 'Acid regurgitation & throat burn', enabled: true },
  { id: 'nausea', name: 'Nausea', shortName: 'Nausea', unit: '/10', description: 'Queasiness, sickness sensation', enabled: true },
  { id: 'vomiting', name: 'Vomiting', shortName: 'Vomiting', unit: '/10', description: 'Emesis', enabled: false },
  { id: 'diarrhea', name: 'Diarrhea', shortName: 'Diarrhea', unit: '/10', description: 'Loose, watery, urgent stools', enabled: true },
  { id: 'constipation', name: 'Constipation', shortName: 'Constipation', unit: '/10', description: 'Hard stools, incomplete evacuation', enabled: true },
  { id: 'headache', name: 'Headache', shortName: 'Headache', unit: '/10', description: 'Head pressure, migraines', enabled: true },
  { id: 'mouth_taste', name: 'Mouth Taste', shortName: 'Mouth Taste', unit: '/10', description: '0 = Pleasant, 10 = Unpleasant', enabled: true },
  { id: 'eczema', name: 'Eczema', shortName: 'Eczema', unit: '/10', description: 'Skin inflammation, itching, rash', enabled: false },
  { id: 'hayfever', name: 'Hayfever', shortName: 'Hayfever', unit: '/10', description: 'Allergic rhinitis, sneezing, congestion', enabled: false },
  { id: 'asthma', name: 'Asthma', shortName: 'Asthma', unit: '/10', description: 'Wheezing, chest tightness, shortness of breath', enabled: false },
];

export const TRACKABLE_SYMPTOMS: TrackableSymptom[] = DEFAULT_TRACKABLE_SYMPTOMS;

export const PRIMARY_SYMPTOM_KEYS = [
  'bloating',
  'stomach_pain',
  'heartburn',
  'reflux',
  'nausea',
  'vomiting',
  'diarrhea',
  'constipation',
  'headache',
  'mouth_taste',
  'eczema',
  'hayfever',
  'asthma',
] as const;

const STORAGE_KEY_SYMPTOMS = 'digestlog_custom_symptoms_v1';

export function getCustomSymptomConfigs(userId?: string | null): TrackableSymptom[] {
  if (typeof window === 'undefined') return DEFAULT_TRACKABLE_SYMPTOMS;
  try {
    const key = userId && userId !== 'usr_harry' ? `${STORAGE_KEY_SYMPTOMS}_${userId}` : STORAGE_KEY_SYMPTOMS;
    const raw = localStorage.getItem(key);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (e) {
    console.warn('Failed to read custom symptoms', e);
  }
  return DEFAULT_TRACKABLE_SYMPTOMS;
}

export function saveCustomSymptomConfigs(configs: TrackableSymptom[], userId?: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    const key = userId && userId !== 'usr_harry' ? `${STORAGE_KEY_SYMPTOMS}_${userId}` : STORAGE_KEY_SYMPTOMS;
    localStorage.setItem(key, JSON.stringify(configs));
    window.dispatchEvent(new CustomEvent('digestlog_symptoms_updated', { detail: configs }));
  } catch (e) {
    console.warn('Failed to save custom symptoms', e);
  }
}

export function getActiveTrackableSymptoms(userId?: string | null): TrackableSymptom[] {
  const all = getCustomSymptomConfigs(userId);
  return all.filter((s) => s.enabled !== false);
}
